/* IMPORT */
import { Stack } from './methods/debugger.js';
/* MAIN - READ */
// This module relies on live-binding of exported variables to avoid a bunch of property accesses
let BATCH;
let OBSERVER;
/* MAIN - WRITE */
// Unfortunately live-bounded exports can't just be overridden, so we need these functions
const setBatch = (value) => BATCH = value;
const setObserver = (value) => OBSERVER = value;
/* EXPORT */
export { BATCH, OBSERVER /* , OWNER, SUPER_OWNER */ };
export { setBatch, setObserver /* , setOwner */ };
